
export default {
    name: 'Item',
    methods: {
        async update_goods_sales(id, params) {
            return await this.$communicator('update_item_fields', {
                arguments: [id],
                params: params
            })
        },
        async get_item_variants(params) {
            return await this.$communicator('list_of_item_variants', {
                params: params
            })
        },
        async get_item_by_id(id) {
            return this.$communicator.then(
                this,
                await this.$communicator("get_item_by_id", {
                    arguments: [id]
                })
            );
        }
    }
}
